import React, { Component, type ReactNode, type KeyboardEvent } from 'react';

type Props = {
	children: ReactNode;
};

// eslint-disable-next-line jira/react/no-class-components
class SuppressEscKey extends Component<Props> {
	onKeyEvent = (e: KeyboardEvent<HTMLElement>) => {
		const { key } = e;
		if (key === 'Escape') {
			e.stopPropagation();
			e.nativeEvent.stopImmediatePropagation();
		}
	};

	render() {
		return (
			<div
				role="presentation"
				onKeyDown={this.onKeyEvent} // prevents modal dialog close
				onKeyUp={this.onKeyEvent} // prevents blurring of input fields
			>
				{this.props.children}
			</div>
		);
	}
}

export default SuppressEscKey;
